export default {
  'base': {
    'Add': '新增',
    'add': '增加',
    'delete': '删除',
    'edit': '编辑',
    'update': '修改',
    'start': '启用',
    'stop': '停用',
    'lock': '已锁定',
    'hasDelete': '已删除',
    'create': '创建',
    'modify': '修改',
    'cancel': '取消',
    'sure': '确定',
    'search': '请输入关键字',
    'select': '请选择下拉选项',
    'import': '批量导入',
    'importT': '批量导入：',
    'export': '批量导出',
    'yes': '是',
    'no': '否',
    'return': '返回',
    'save': '保存',
    'PleaseInputAValidPhoneNumber': '请输入正确的手机号',
    'PleaseInputAValidEmail': '请输入正确的邮箱地址',
    'PleaseEnterChinese': '请输入中文',
    'PleaseEnterEnglish': '请输入英文',
    'PleaseEnterEnglishOrNumbers': '请输入英文或数字',
    'importSuccess': '导入成功',
    'OnlyCanInputLettersNumbersOrPoint': '只能输入字母、数字或者“.”、“_”，以字母开头，不能以“.”结尾，“.”不能连续',
    'OnlyCanInputZhEnOrSign': '只能输入中文、英文、中划线和半角符号的括号',
    'OnlyCanInputEnOrSign': '只能输入英文、中划线和半角符号的括号',
    'OnlyCanInputEnOrSpace': '只能输入英文、数字及特殊字符（含空格）',
    'OnlyCanInputChineseOrLetters': '只能输入中文或英文',
    'toClose': '确认关闭？关闭后已输入内容将丢失。',
    'confirmToClose': '确认关闭',
    'UnknownError': '未知错误，请稍后重试',
    'FileTypeError': '文件格式错误',
    'FileSizeTooLarge': '文件大小不得超过1MB',
    'PleaseChooseOrg': '请选择机构',
    'PleaseSelect': '请选择',
    'createdAt': '创建时间',
    'updateAt': '更新时间',
    'Operation': '操作',
    'AreYouSureToDelete': '您确定删除 {name} 吗？确定后该{moduleName}将无法恢复。',
    'noData': '暂无数据',
    'tip': '提示',
    'date': '天',
    'hour': '小时',
    'startTime': '开始日期',
    'ensTime': '结束日期',
    'min': '分钟',
    'space': '',
    'numberTip': '请输入正确的座机号码或手机号',
    'relateUser': '关联用户',
    'relateRole': '关联角色',
    'relateJob': '关联岗位',
    'productOrder': '产品序列',
    'yeePayId': '商户号',
    'yeeMerNo': '易宝子商户号',
    'shopCode': '二网ERP号',
    'salesCar': '可售车系',
    'city': '所在城市',
    'province': '所在省份',
    'region': '所在区域'
  },
  'common': {
    'allTotal': '共{total}条记录',
    'pageInfo': '第{pageinfo}页 ',
    'province': '省',
    'city': '市',
    'region': '区县',
    'form': {
      'notNum': '只能输入字母或者“.”，并且不能以“.”结尾'
    }
  },
  'sidebar': {
    'orgManage': '组织机构管理',
    'orgList': '组织机构列表',
    'addOrg': '添加机构',
    'detailOrg': '机构详情',
    'editOrg': '机构编辑',
    'editDepartment': '部门编辑',
    'addDepartment': '添加部门',
    'detailDepartment': '部门详情',
    'privilegeManage': '权限管理',
    'privilegeList': '权限列表',
    'detailPrivilege': '权限管理详情',
    'menuManage': '菜单管理',
    'menuList': '菜单列表',
    'detailMenu': '菜单详情',
    'postManage': '岗位管理',
    'postList': '岗位列表',
    'districtManage': '行政区划管理',
    'districtList': '行政区划列表',
    'detailDistrict': '行政区划详情',
    'editDistrict': '行政区划编辑',
    'saleManage': '销售区划管理',
    'secondNetwork': '二网协同销售区划',
    'saleList': '销售区划列表',
    'detailSale': '销售区划详情',
    'editSale': '销售区划编辑',
    'thirdPartManage': '第三方接入管理',
    'thirdPartList': '第三方接入列表',
    'Dashboard': '工作台',
    'UserMng': '用户管理',
    'UserList': '用户列表',
    'District': '行政区划',
    'RoleMng': '角色管理',
    'RoleList': '角色列表',
    'RoleDetails': '角色详情',
    'RoleAdd': '添加角色',
    'RoleEdit': '编辑角色',
    'PostMng': '岗位管理',
    'PostList': '岗位列表',
    'AppMng': '应用管理',
    'AppList': '应用列表',
    'AppAdd': '添加应用',
    'AppEdit': '编辑应用',
    'editPosition': '岗位编辑',
    'detailPosition': '岗位详情',
    'UserInfo': '帐号信息',
    'InfoMng': '信息管理',
    'BaseInfo': '基本信息',
    'SetPwd': '修改密码',
    'SetPhone': '修改手机',
    'SetEmail': '修改邮箱',
    'ReportExport': '报表导出',
    'Log': '日志管理',
    'LogList': '日志列表',
    'ReportLine': '组织汇报线',
    'creditDevice': '授信设备',
    'creditDeviceList': '授信设备列表',
    'creditDeviceAudit': '授信设备审核',
    'shortMsgConf': '短信配置',
    'UserMng2C': 'C端用户管理',
    'StaffMng': '员工管理'
  },
  'Navbar': {
    'Home': '首页',
    'UserInfo': '帐号信息',
    'LogOut': '退出登录',
    'AppSwitch': '应用切换'
  },
  'lang': {
    'zh': '简体中文',
    'en': 'English'
  },
  'org': {
    'AllOrg': '全部机构',
    'Org': '机构',
    'Dep': '部门',
    'insList': '机构列表',
    'depList': '部门列表',
    'PleaseInputOrgName': '请输入机构名称',
    'PleaseInputOrgCode': '请输入机构编码',
    'PleaseSelectShopCode': '请选择二网ERP号',
    'PleaseSelectProductOrder': '请选择产品序列',
    'newSalingDealer': '新零售业务',
    'table': {
      'status': '机构状态',
      'yeePayId': '商户号',
      'yeeMerNo': '易宝子商户号',
      'shopCode': '二网ERP号',
      'insAllName': '机构全称',
      'insName': '机构全称',
      'insCode': '机构编码',
      'insStatus': '机构状态',
      'insDes': '机构简介',
      'depName': '部门名称',
      'supName': '上级名称',
      'depStatus': '部门状态',
      'depDes': '部门简介',
      'regionalManagerInfo': '销售区划',
      'productOrder': '产品序列'
    },
    'manage': '机构管理',
    'name': '组织机构：',
    'add': '添加机构',
    'orgInfo': '机构信息',
    'concatInfo': '联系信息',
    'editOrg': '机构编辑',
    'resetPwd': '重置密码',
    'PleaseSelect': '请选择',
    'Organization': '组织机构',
    'Select': '选择',
    'ChosenInstitution': '已选择机构',
    'Unselect': '取消选择',
    'chooseRole': '选择角色',
    'PleaseInputPwd': '请输入密码',
    'PleaseInputTheCorrectPassword': '请输入格式正确的密码',
    'PwdDesc': '密码长度10~16位，至少包含：大写字母、小写字母、数字或特殊字符(只能包括`~!@#$%^&*()_-)中的三种',
    'pleaseChooseOrg': '请选择组织机构',
    'PleaseSelectRoles': '请选择角色',
    'SuccessfullyResetPwd': '机构重置密码成功',
    'edit': '组织编辑',
    'addDepart': '添加部门',
    'editDepart': '部门编辑',
    'detailDepart': '部门详情',
    'detailPosition': '岗位详情',
    'editPosition': '岗位编辑',
    'search': '请输入关键字',
    'PleaseInputInstitutionName': '请输入机构名称或编码',
    'select': '请选择下拉选项',
    'detail': '机构详情',
    'import': '批量导入',
    'importT': '批量导入：',
    'browse': '浏览',
    'upload': '上传',
    'importInfo': '导入说明：',
    'importDes': '1.在模板中填写好文件;2.上传填写好的文件;3.导入上传',
    'clickThis': '点击此处',
    'importTem': '下载导入模板',
    'export': '批量导出',
    'toClose': '确认关闭？',
    'deleteOrgInfo': '删除该组织机构，删除后无法恢复，确认要删除？',
    'deleteDepartInfo': '删除该部门，删除后无法恢复，确认要删除？',
    'deletePostInfo': '删除该职务，删除后无法恢复，确认要删除？',
    'tip': '提示',
    'PleaseInputOrgRegionalManagerInfo': '请输入销售区划',
    'PleaseInputOrgsecondNetworkERP': '请输入二网ERP号',
    'form': {
      'PleaseAtLeastSelectCity': '请至少选择至市级',
      'managerMobile': '总经理：',
      'pleaseInputManagerMobile': '请输入总经理手机号',
      'adminMobile': '经销商管理员：',
      'pleaseInputAdminMobile': '请输入经销商管理员手机号',
      'pleaseInputSalesHotline': '请输入销售热线',
      'pleaseInputServiceHotline': '请输入服务热线',
      'type': '节点类型：',
      'full': '机构全称：',
      'dFull': '部门名称：',
      'parent': '上级部门：',
      'dStatus': '部门状态：',
      'num': '部门人数：',
      'dArea': '所在区域：',
      'dContacts': '部门联系人：',
      'dDescription': '部门简介：',
      'status': '机构状态：',
      'division': '行政区划：',
      'code': '机构编码：',
      'address': '地址信息：',
      'tel': '联系手机号：',
      'manager': '机构管理员：',
      'contacts': '机构联系人：',
      'create': '创建时间：',
      'start': '启用时间：',
      'description': '部门简介：',
      'orgDescription': '机构简介：',
      'placeholder': '请选择节点类型',
      'chooseStatus': '请选择状态',
      'nodeError': '获取节点类型列表失败',
      'statusError': '获取机构状态列表失败',
      'addSuccess': '增加成功',
      'addError': '增加失败',
      'uploadSuccess': '上传成功',
      'uploadError': '上传失败',
      'modifySuccess': '修改成功',
      'modifyError': '修改失败',
      'deleteSuccess': '删除成功',
      'deleteError': '删除失败',
      'deleteCancel': '已取消删除',
      'errorInfo': '不能为空',
      'adDivision': '行政区划：',
      'errorReg': '格式不正确',
      'position': '岗位名称：',
      'alias': '别名：',
      'belongDepart': '所属部门：',
      'demand': '任职要求：',
      'limit': '岗位上限：',
      'positionDes': '岗位描述：',
      'need': '是否需要面试',
      'training': '是否需要培训',
      'partTime': '是否可兼职',
      'manage': '是否管理岗位',
      'depart': '部门',
      'post': '职务',
      'person': '人',
      'postStatus': '岗位状态：',
      'entityCode': '实体代码：',
      'serviceCode': '售后代码：',
      'businessNo': '子商户编号: ',
      'serviceArea': '服务范围：',
      'pleaseSelectServiceArea': '请选择服务范围',
      'uploadImg': '上传图片：',
      'uploadVideo': '上传视频：',
      'departType': '部门类别：',
      'salesHotline': '销售热线：',
      'serviceHotline': '服务热线：',
      'longitude': '经度',
      'latitude': '纬度',
      'longitudeTip': '请输入正确的经度',
      'latitudeTip': '请输入正确的纬度',
      'addressTip': '未查询到该地址的有效经纬度信息',
      'placeholderCarSeriesOnType': '请选择可售车系',
      'zipCode': '邮编：',
      'fax': '服务站传真：',
      'openingTime': '入网时间',
      'location': '位置',
      'salesFax': '销售传真',
      'salesPhone': '销售热线：',
      'detail': '机构地址：',
      'phone': '服务站电话：',
      'hotline': '24小时救援热线：',
      'manager': '机构管理员：',
      'contacts': '机构联系人：',
      'create': '创建时间：',
      'start': '启用时间：',
      'update': '更新时间：',
      'description': '部门简介：',
      'placeholder': '请选择节点类型',
      'chooseStatus': '请选择状态',
      'nodeError': '获取节点类型列表失败',
      'statusError': '获取机构状态列表失败',
      'position': '岗位名称：',
      'alias': '别名：',
      'abbreviation': '机构简称：',
      'yeeMerNo': '易宝子商户号：',
      'safeAccount': '平安支付：',
      'safeBill': '平安账户: ',
      'carSeriesOnType': '可售车系：',
      'newSalingDealer': '支持新零售：',
      'detail': '机构地址'
    }
  },
  'privilege': {
    'privilegeList': '权限列表',
    'manage': '权限管理',
    'name': '权限名称',
    'code': '权限码',
    'description': '权限简介',
    'updatedAt': '修改时间',
    'belongApp': '所属应用',
    'PleaseChooseApp': '请选择所属应用',
    'firstLevelPrivilege': '一级权限',
    'PleaseChooseFirstLevelPrivilege': '请选择一级权限',
    'secondLevelPrivilege': '二级权限',
    'PleaseChooseSecondLevelPrivilege': '请选择二级权限',
    'addPrivilege': '添加权限',
    'detail': '权限详情',
    'edit': '编辑权限',
    'form': {
      'privilegeName': '权限名称：',
      'code': '权限码：',
      'description': '权限简介：',
      'create': '创建时间：',
      'modify': '修改时间：',
      'deletePriInfo': '删除该权限，删除后无法恢复，确认要删除？'
    }
  },
  'menu': {
    'Menu': '菜单',
    'name': '名称',
    'category': '类别',
    'url': '链接地址',
    'relatedPri': '关联权限',
    'detail': '菜单详情',
    'manage': '菜单管理',
    'belongApp': '所属应用',
    'PleaseChooseApp': '请选择所属应用',
    'firstLevelMenu': '一级菜单',
    'thirdLevelMenu': '三级菜单',
    'fourthLevelMenu': '四级菜单',
    'PleaseChooseFirstLevelMenu': '请选择一级菜单',
    'PleaseChooseThirdLevelMenu': '请选择三级菜单',
    'PleaseChooseFourthLevelMenu': '请选择四级菜单',
    'secondLevelMenu': '二级菜单',
    'PleaseChooseSecondLevelMenu': '请选择二级菜单',
    'menuList': '菜单列表',
    'addMenu': '新增一级菜单',
    'edit': '编辑菜单',
    'del': '你确定要删除该菜单？确定后无法恢复',
    'nullData': '获取数据为空',
    'form': {
      'name': '菜单名称：',
      'displayCN': '菜单中文显示名称：',
      'displayEN': '菜单英文显示名称：',
      'link': '菜单链接地址：',
      'isVirtual': '是否虚拟菜单：',
      'isAlert': '是否弹窗显示：',
      'category': '菜单类别：',
      'description': '简介：',
      'relatedPri': '关联权限：',
      'create': '创建时间：',
      'modify': '修改时间：',
      'btnName': '按钮名称：',
      'pageId': '菜单编码：',
      'resourceId': '按钮编码：',
      'btnCategory': '按钮类别：',
      'btnDes': '按钮简介：',
      'addCategory': '新增类型：',
      'domain': '菜单链接域名：',
      'btnDomain': '按钮链接域名：',
      'path': '菜单链接路径：',
      'addMenu': '添加菜单',
      'btnCN': '按钮中文显示名称：',
      'btnEN': '按钮英文显示名称：',
      'priority': '排序权重',
      'isShow': '是否展示'
    }
  },
  'district': {
    'District': '行政区划',
    'country': '国家',
    'province': '省级',
    'city': '市级',
    'PleaseSelectCountry': '请选择国家',
    'PleaseSelectProvince': '请选择省',
    'PleaseSelectCity': '请选择市',
    'detail': '行政区划详情',
    'full': '区划全称',
    'short': '区划简称',
    'code': '区划编码',
    'cityLevel': '城市分类',
    'parentName': '上级行政区名称',
    'parentCode': '上级行政区编码',
    'list': '行政区划列表',
    'edit': '编辑行政区划',
    'add': '添加行政区划',
    'delete': '行政区划删除',
    'tip': '您确定要删除该节点？确定后该节点以及其子节点将无法恢复。',
    'form': {
      'name': '区划名称：',
      'short': '区划简称：',
      'code': '区划编码：',
      'full': '全称：',
      'city': '城市分类：',
      'parentDistrict': '上级行政区名称：',
      'parentCode': '上级行政区编码：',
      'outdate': '是否过期：',
      'expiredPlace': '请选择是否过期',
      'hasExpired': '已过期',
      'notExpired': '未过期',
      'cityPlace': '请选择城市等级'
    }
  },
  'sale': {
    'Sale': '销售区划',
    'firstLevel': '一级区划',
    'secondLevel': '二级区划',
    'thirdLevel': '三级区划',
    'PleaseSelectFirstLevel': '请选择一级区划',
    'PleaseSelectSecondLevel': '请选择二级区划',
    'PleaseSelectThirdLevel': '请选择三级区划',
    'detail': '销售区划详情',
    'list': '销售区划列表',
    'info': '区划信息',
    'delete': '销售区划删除',
    'edit': '编辑销售区划',
    'tip': '您确定要删除该节点？确定后该节点以及其子节点将无法恢复。',
    'parent': '上级区划',
    'form': {
      'name': '区划名称',
      'code': '区划编码',
      'description': '区划描述',
      'region': '管辖范围',
      'parentName': '上级区划名称',
      'parentSale': '上级区划编码',
      'addSale': '添加销售区划',
      'productOrder': '产品序列'
    }
  },
  'networkSale': {
    'Sale': '协同销售区划',
    'firstLevel': '一级区划',
    'secondLevel': '二级区划',
    'thirdLevel': '三级区划',
    'productOrder': '产品序列',
    'PleaseSelectFirstLevel': '请选择一级区划',
    'PleaseSelectSecondLevel': '请选择二级区划',
    'PleaseSelectThirdLevel': '请选择三级区划',
    'PleaseSelectProductOrder': '请选择产品序列',
    'detail': '协同销售区划详情',
    'list': '协同销售区划列表',
    'info': '区划信息',
    'delete': '协同销售区划删除',
    'edit': '编辑协同销售区划',
    'tip': '您确定要删除该节点？确定后该节点以及其子节点将无法恢复。',
    'parent': '上级区划',
    'form': {
      'name': '区划名称',
      'productOrder': '产品序列',
      'code': '区划编码',
      'description': '区划描述',
      'region': '管辖范围',
      'parentName': '上级区划名称',
      'parentSale': '上级区划编码',
      'addSale': '添加协同销售区划'
    }
  },
  'user': {
    'User': '用户',
    'Position': '岗位',
    'pleaseChooseOrg': '请选择组织机构',
    'UserMng': '用户管理',
    'Dealer': '经销商',
    'OEM': '主机厂',
    'PleaseSelect': '请选择',
    'PleaseInputInstitutionName': '请输入机构名称或编码',
    'Select': '选择',
    'ChosenInstitution': '已选择机构',
    'Unselect': '取消选择',
    'ExportInstructions': '导出说明',
    'ExportUpTo60': '一次至多导出60家机构数据',
    'IfChooseNoneExportAll': '如果不选择，默认为导出所有用户',
    'Organization': '组织机构',
    'UserList': '用户列表',
    'Export': '导出',
    'Import': '导入',
    'BatchExport': '批量导出',
    'BatchImport': '批量导入',
    'ShowDetails': '查看详情',
    'Start': '启用',
    'Stop': '停用',
    'Edit': '编辑',
    'Delete': '删除',
    'BatchStart': '批量启用',
    'BatchStop': '批量停用',
    'BatchDelete': '批量删除',
    'AssociateRoles': '关联角色',
    'BrowseFile': '浏览',
    'Upload': '上传',
    'ImportInstructions': '导入说明',
    'ClickHere': '点击此处',
    'DownloadImportTemplateFile': '下载导入模板文件',
    'FillImportFile': '在模板中填写好文件',
    'ChooseFile': '上传填写好的文件',
    'UploadFile': '导入上传',
    'UserInfo': '用户详情',
    'Name': '姓名',
    'InOrganization': '所属机构',
    'Manager': '管理员',
    'ManagerDep': '管理员机构',
    'EmpNo': '工号',
    'HotEmpNo': '热线坐席工号',
    'Cellphone': '手机',
    'Email': '邮箱',
    'DepPost': '部门岗位表',
    'DirectSuperiors': '直属上级',
    'Post': '岗位',
    'manageInstitution': '管理全店',
    'UserRoles': '用户角色表',
    'EditUser': '编辑用户',
    'AddUser': '添加用户',
    'DataCollision': '数据冲突',
    'UserAlreadyExists': '用户已存在，是否关联？',
    'SuccessfullyAdded': '添加成功',
    'MustInputCellphoneOrEmail': '手机邮箱至少填写一项',
    'PleaseFillInCellphoneNumberOrEmail': '请填写手机或邮箱',
    'PleaseSelectPost': '请选择岗位',
    'PleaseSelectSuperiorPost': '请选择直属上级岗位',
    'SuccessfullyUpdated': '更新成功',
    'SuccessfullyDeleted': '删除成功',
    'DeleteUser': '删除用户',
    'selectedUsers': '选中的用户',
    'AreYouSureToStartOrStopThisUser': '您确定{operation} {name} 吗？',
    'SuccessfullyStarted': '启用成功',
    'SuccessfullyStoped': '停用成功',
    'SuccessfullyAssociated': '关联成功',
    'DisplayName': '用户名称',
    'PleaseInputUserName': '请输入用户名称',
    'PleaseInputCellphoneNumber': '请输入手机号',
    'PleaseInputDisplayName': '请输入姓名',
    'PleaseInputEmpNo': '请输入工号',
    'PleaseInputHotEmpNo': '请输入热线坐席工号',
    'PleaseInputEmail': '请输入邮箱',
    'PleaseInputPostName': '请输入岗位名称',
    'Operation': '操作',
    'Phone': '用户手机',
    'Department': '所属部门',
    'SuccessfullyImported': '导入成功',
    'ResetPwd': '重置密码',
    'InitialPwd': '初始化密码',
    'PleaseInputTheCorrectPassword': '请输入格式正确的密码',
    'PwdDesc': '密码长度10~16位，至少包含：大写字母、小写字母、数字或特殊字符(只能包括`~!@#$%^&*()_-)中的三种',
    'SuccessfullyResetPwd': '重置密码成功',
    'randomPwd': '随机密码',
    'userDefined': '自定义密码',
    'PleaseInputPwd': '请输入密码',
    'PleaseInputResetPwd': '请输入重置密码',
    'reportTo': '汇报对象',
    'DtPermissionRange': '数据权限范围',
    'PleaseSelectReportTo': '请选择汇报对象',
    'PleaseSelectPermissionRange': '请选择数据权限范围',
    'orgReportLine': '汇报线视图',
    'Account': '帐号',
    'Audit': '审批人',
    'SuperPwd': '超级密码',
    'Open': '开启',
    'Close': '关闭',
    'confirmToOpenPwd': '您确定开启 {name} 超级密码登录吗？该操作可能会影响用户登录。',
    'PleaseInputAccount': '请输入帐号',
    'PleaseSelectDepart': '请选择部门',
    'PleaseSelectOneDepart': '请至少选择1个部门',
    'PleaseSelectDepartType': '请选择部门类别',
    'loginAuthentication': '登录认证',
    'UploadAvatarOnlyDealer': '上传头像（仅销售岗）',
    'Avatar': '图片：',
    'Video': '视频：',
    'uploadTypeTip': '上传文件格式仅支持：',
    'uploadSizeTip': '上传文件大小不能超过',
    'uploadLimitTip': '当前限制选择 {limit} 个文件',
    'uploading': '上传中...',
    'Depart': '部门',
    'MngPost': '管理岗位'
  },
  'searchPanel': {
    'StartDate': '开始时间',
    'EndDate': '结束时间',
    'Search': '搜索',
    'Reset': '重置',
    'PleaseInput': '请输入',
    'PleaseSelect': '请选择'
  },
  'role': {
    'RoleTags': '关联标签',
    'pleaseSelectApp': '请选择所属应用',
    'PleaseSelectTags': '请选择标签',
    'RoleList': '角色列表',
    'Role': '角色',
    'App': '所属应用',
    'RoleName': '角色名称',
    'PleaseChooseApp': '请选择所属应用',
    'PleaseInputRoleName': '请输入角色名称',
    'AddRole': '新增角色',
    'RoleDescription': '角色描述',
    'Category': '所属类别',
    'Automaker': '主机厂',
    'Dealer': '经销商',
    'Designer': '设计师',
    'Supplier': '供应商',
    'Client': '消费者',
    'BatchDelete': '批量删除',
    'DeleteRole': '删除角色',
    'SelectedRole': '选中的角色',
    'AreYouSureToDelete': '您确定删除',
    'RoleMng': '角色管理',
    'Back': '返回',
    'MenuInfo': '菜单信息',
    'ButtonInfo': '按钮信息',
    'Department': '所属部门',
    'RoleCode': '角色编码',
    'RoleType': '角色类别',
    'MenuAuthority': '菜单权限树',
    'MenuName': '菜单名称',
    'ButtonName': '按钮名称',
    'MenuUrl': '菜单链接地址',
    'ButtonPageID': '菜单编码',
    'ButtonResourceID': '按钮编码',
    'Description': '简介',
    'ButtonDescription': '按钮简介',
    'Authority': '关联权限',
    'CreatedTime': '创建时间',
    'ModifiedTime': '修改时间',
    'RelatedUser': '角色关联用户',
    'BaseInfo': '基本信息',
    'Save': '保存',
    'RoleCategory': '角色类别',
    'PleaseInputName': '请输入角色名称',
    'PleaseChooseCategory': '请选择角色类别',
    'PleaseInputRoleCode': '请输入角色编码',
    'PleaseInputRoleDesc': '请输入角色描述',
    'TheFormatIsIncorrect': '只能输入字母或者“.”，并且不能以“.”开头或结尾',
    'SuccessfullyCreated': '创建成功',
    'SuccessfullyUpdated': '修改成功',
    'SuccessfullyImported': '导入成功',
    'updateConfirm': '修改角色信息影响较大，请确认是否修改？'
  },
  'app': {
    'app': '应用',
    'AppList': '应用列表',
    'AddApp': '添加应用',
    'Keyword': '关键字',
    'PleaseInputAppName': '请输入应用名称',
    'AppName': '应用名称',
    'PleaseInputAppEnName': '请输入应用英文名称',
    'AppEnName': '应用英文名称',
    'AppCode': '应用编码',
    'AppUrl': '应用链接',
    'DeleteApp': '应用删除',
    'Url': '链接地址',
    'AppIcon': '应用图标',
    'AppIntro': '应用简介',
    'OpenInNewWindow': '新窗口打开',
    'PleaseInputCode': '请输入应用编码',
    'PleaseInputName': '请输入应用名称',
    'PleaseInputUrl': '请输入链接地址',
    'PleaseInputAppIntro': '请输入应用简介',
    'TheIconIsMissing': '无法获取该应用图标数据',
    'AppId': 'AppId',
    'supportDimission': '支持离职',
    'equipmentValidation': '设备验证',
    'details': '应用详情',
    'expired': '访问过期',
    'autoAudit': '设备自动审核',
    'TimeGreaterThan0': '时间必须大于0',
    'shortMsgConf': '短信配置',
    'GetCaptchaByPhoneNo': '通过手机号获取验证码',
    'AdminResetPwd': '管理员重置用户密码',
    'Pwd7daysRemind': '密码过期前7天每天提醒',
    'PwdExpiredRemind': '密码过期后提醒',
    'PwdSuccessfullyChange': '密码修改成功提醒',
    'PleaseInputShortMsgSignature': '请输入短信签名',
    'PleaseInputTemplateCode': '请输入短信模板编码',
    'SignatureAndTemplateCodeCanNotOnlyInputOne': '请同时填写短信签名和模板编码',
    'SuccessfullyChangeConfig': '短信模板配置成功',
    'PleaseInputAccessEffectiveDuration': '请输入访问过期时间',
    'HourMustLessThan24': '小时数必须为0~24(不包括24)的一位小数',
    'DateMustBeIntAndLessThan99': '天数必须为0~99之间的正整数'
  },
  'thirdPart': {
    'thirdAccess': '第三方接入',
    'thisUser': '该接入方',
    'AccessDetails': '接入方详情',
    'list': '第三方接入列表',
    'user': '接入方',
    'client': 'client_id',
    'create': '创建时间',
    'start': '开始日期',
    'end': '结束日期',
    'no': '序号',
    'createTime': '创建时间',
    'access': '接入方',
    'clientId': 'CLIENT_ID',
    'secret': 'CLIENT_SECRET',
    'logout': '登出回调',
    'introduction': '简介',
    'operation': '操作',
    'add': '添加接入方',
    'edit': '编辑接入方',
    'delete': '删除接入方',
    'del': '确定删除该接入方？',
    'PleaseInputLogout': '请输入登出回调'
  },
  'userInfo': {
    'accountRule': '账号长度不超过30位，可包含数字、中英文字符、特殊字符',
    'pwdDesc': '密码长度10~16位，至少包含：大写字母、小写字母、数字或特殊字符(只能包括`~!@#$%^&*()_-)中的三种',
    'PleaseImproveYourPersonalInformation': '请完善个人信息',
    'UserInfo': '用户信息',
    'AccountInfo': '帐号信息',
    'BaseInfo': '基本信息',
    'SetPwd': '修改密码',
    'SetPhone': '修改手机',
    'SetEmail': '修改邮箱',
    'Name': '姓名',
    'QQ': 'QQ',
    'Wechat': '微信',
    'Mobile': '手机',
    'Email': '电子邮箱',
    'PleaseInputName': '请输入姓名',
    'SuccessfullyUpdated': '修改成功',
    'EmployeeNo': '员工编号',
    'Account': '帐号',
    'Institution': '所属机构',
    'Department': '所属部门',
    'Post': '所属岗位',
    'PleaseInputAccount': '请输入帐号',
    'PleaseInputTheCorrectAccount': '请输入格式正确的帐号',
    'CannotBeLongerThan20Characters': '不得超过20个字符',
    'CannotBeLongerThan30Characters': '不得超过30个字符',
    'OldPwd': '旧密码',
    'NewPwd': '新密码',
    'InputNewPwdAgain': '再次输入新密码',
    'ChangePwd': '修改密码',
    'PleaseInputOldPwd': '请输入旧密码',
    'PleaseInputNewPwd': '请输入新密码',
    'PleaseInputNewPwdAgain': '请再次输入新密码',
    'PleaseInputTheCorrectPassword': '请输入格式正确的密码',
    'ThePasswordsEnteredTwiceAreNotTheSame': '两次输入的密码不一致',
    'changePwdSuccessfully': '修改密码成功',
    'mobileNo': '手机号码',
    'VerifyCode': '验证号码',
    'ChangePhoneNumber': '更换手机号',
    'Sure': '确定',
    'PleaseInputVerificationCode': '请输入验证码',
    'VerificationCode': '验证码',
    'GetVerificationCode': '获取验证码',
    'GetVerificationCodeAfter': '{countdown}秒后可再次获取',
    'MobileVerifiedSuccessfully': '验证手机成功',
    'PleaseInputCellphoneNo': '请输入手机号码',
    'ChangeMobile': '修改手机',
    'SuccessfullyChangeCellphoneNo': '修改手机号码成功',
    'PleaseInputEmailAddr': '请输入邮箱地址',
    'ChangeEmail': '修改邮箱',
    'EmailVerifiedSuccessfully': '邮箱验证成功',
    'SuccessfullyChangeEmail': '修改邮箱成功',
    'VerificationCodeSentSuccessfully': '验证码已成功发送至{mobileEmail}',
    'ReportTo': '汇报对象',
    'Audit': '审批人',
    'DtRange': '数据权限'
  },
  'operation': {
    'addSuccess': '添加成功!',
    'delSuccess': '删除成功!',
    'editSuccess': '编辑成功!'
  },
  'postManagement': {
    'postList': '岗位列表',
    'UserName': '岗位名称',
    'AssociateRoles': '关联角色',
    'Description': '简介',
    'status': '状态',
    'CreatedAt': '创建时间',
    'Lastmodified': '最后修改时间',
    'Operation': '操作',
    'PleaseInputUserName': '请输入岗位名称',
    'PleaseSelectStatus': '请选择状态',
    'Enable': '启用',
    'stopUsing': '停用'
  },
  'post': {
    'PostTags': '关联标签',
    'PleaseSelectTags': '请选择标签',
    'PostList': '岗位列表',
    'Post': '岗位',
    'RelateJobSuc': '绑定岗位成功',
    'removeRelateJobSuc': '解绑岗位成功',
    'BatchExport': '批量导出',
    'BatchImport': '批量导入',
    'Import': '导入',
    'BrowseFile': '浏览',
    'Upload': '上传',
    'ImportInstructions': '导入说明',
    'ClickHere': '点击此处',
    'DownloadImportTemplateFile': '下载导入模板文件',
    'FillImportFile': '在模板中填写好文件',
    'ChooseFile': '上传填写好的文件',
    'UploadFile': '导入上传',
    'FileTypeError': '文件格式错误',
    'AddPost': '添加岗位',
    'PleaseInputPostName': '请输入岗位名称',
    'PleaseSelect': '请选择',
    'Level': '等级',
    'PostName': '岗位名称',
    'PostLevel': '岗位等级',
    'DirectSuperiors': '直属上级',
    'IsOperations': '是否运维岗',
    'IsManager': '是否管理岗',
    'CreatedTime': '创建时间',
    'PostDes': '岗位描述',
    'Operation': '操作',
    'PleaseSelectPostLevel': '请选择岗位等级',
    'PleaseInputPostDescription': '请输入岗位描述',
    'UpdatePostSuccessfully': '更新岗位成功',
    'CreatePostSuccessfully': '创建岗位成功',
    'BatchDelete': '批量删除',
    'DeletePost': '岗位删除',
    'AreYouSureToDelete': '您确定删除',
    'SelectedPost': '选中的岗位',
    'SuccessfullyDeleted': '删除成功',
    'EditPost': '岗位编辑',
    'PostDetails': '岗位详情'
  },
  'reportExport': {
    'reportDataExport': '报表明细数据导出',
    'startMonth': '起始月份：',
    'endMonth': '截止月份：',
    'Export': '导出数据',
    'PleaseSelect': '请选择',
    'Remarks': '备注：',
    'reportExportRemarks': '把所选范围内的经销商客源、潜客、订单数据从数据库中导出到OSS上，供经销商下载',
    'timeError': '起始月份不得大于截止月份',
    'exportSuccess': '数据导出成功',
    'notNull': '起始月份、截止月份均不能为空'
  },
  'log': {
    'LogList': '日志列表',
    'Phone': '手机号',
    'UserPhone': '用户手机号',
    'PleaseInputUserPhone': '请输入用户手机',
    'ApiDesc': '接口描述',
    'PleaseInputApiDesc': '请输入接口描述',
    'CreateTime': '创建时间',
    'StartTime': '开始时间',
    'EndTime': '结束时间',
    'UserName': '用户名称',
    'Post': '角色',
    'Org': '机构',
    'ApiType': '请求类型',
    'ApiUrl': '请求接口',
    'Result': '操作结果',
    'Time': '操作时间',
    'Success': '成功',
    'Fail': '失败',
    'Create': '新增',
    'Update': '更新',
    'Delete': '删除',
    'Query': '查询'
  },
  'reportLine': {
    'Audit': '审',
    'CanSeeAllData': '可看全店',
    'CanSeeSubordinate': '仅可看自己及下属',
    'CanSeeOnlySelf': '仅可看自己'
  },
  'creditDevice': {
    'CreditDevice': '授信设备',
    'Code': '设备编码',
    'UserName': '用户名称',
    'UserPhone': '用户手机',
    'PleaseInputDeviceCode': '请输入设备号',
    'PleaseInputUserName': '请输入用户名称',
    'PleaseInputPhone': '请输入手机号',
    'AppName': '应用名称',
    'Org': '所属机构',
    'Dep': '所属部门',
    'CreatedAt': '创建时间',
    'Operation': '操作',
    'Delete': '删除设备',
    'SuccessfullyDeleted': '删除设备成功',
    'SelectedCreditDevices': '选中的授信设备',
    'AreYouSureToDelete': '您确定删除 {code} 吗？确定后数据将无法恢复。',
    'StartAutoAudit': '开启自动审核',
    'CloseAutoAudit': '关闭自动审核',
    'AreYouSure': '您确定 {operation} 吗？',
    'Successfully': '成功',
    'Resolve': '通过',
    'Reject': '拒绝',
    'AreYouSureToAudit': '您确定{operation} {code} 的审核申请吗？',
    'Selected': '选中的',
    'Audit': '审核',
    'Confirm': '确认',
    'Batch': '批量'
  },
  'carCode': {
    'Car': '车型',
    'CarCodeTitle': '车型编码管理',
    'CarCodeTableList': '全部机构',
    'AddCarCode': '添加车型编码',
    'syncCarCode': '同步',
    'EditCarCode': '编辑车型编码',
    'CarCode': '车型编码',
    'CarName': '车型名称',
    'PleaseInputCarCode': '请输入车型编码',
    'PleaseInputCarName': '请输入车型名称',
    'Status': '状态'
  },
  'datasync': {
    'sync': '数据同步日志',
    'regionalManagerInfo': '销售区划',
    'staff': '员工',
    'request': '请求结果',
    'requestType': '请求类型',
    'remark': '备注',
    'logDetail': '日志详情',
    'groupCode': '岗位编码',
    'groupName': '岗位名称',
    'groupCodePlaceholder': '请输入岗位编码',
    'groupNamePlaceholder': '请输入岗位名称',
    'employeeCode': '员工id',
    'employeeInfo': '员工信息',
    'employeeCodePlaceholder': '请输入员工id',
    'employeeInfoPlaceholder': '请输入姓名或手机号',
    'employeeName': '姓名',
    'employeePhone': '手机号',
    'employeeDl': '所属机构',
    'detail': '详情',
    'shopCode': '二网ERP号',
    'productOrder': '产品序列'
  },
  'job': {
    'Name': '岗位名称',
    'jobCode': '岗位编码',
    'jobType': '岗位类型',
    'jobDec': '岗位描述',
    'addJob': '添加岗位',
    'addJobUser': '添加成员',
    'personDec': '（{number}人）',
    'removeJobUser': '批量移除',
    'removeJob': '批量移除',
    'QualificationStandard': '资质标准',
    'TrainingStandard': '培训标准',
    'Job': '岗位',
    'NeedQualificationStandard': '所需资质标准',
    'NeedTrainingStandard': '所需培训标准',
    'AreYouSureToDelete': '您确定删除该岗位吗？删除后已关联岗位的员工将取消关联。',
    'PleaseInputPostName': '请输入岗位名称',
    'PleaseInputPostCode': '请输入岗位编码',
    'PleaseSelectPostType': '请选择岗位类型',
    'PleaseInputPostDec': '请输入岗位描述'
  },
  'staff': {
    'StaffList': '员工列表',
    'StaffDetail': '员工详情',
    'StaffEdit': '编辑员工',
    'Name': '姓名',
    'Mobile': '手机号',
    'QualificationSituation': '资质上传情况',
    'TrainingSituation': '培训完成情况',
    'Achievement': '绩效',
    'Undone': '未完成',
    'Completed': '已完成',
    'NotUploaded': '未上传',
    'Uploaded': '已上传',
    'RelatedPosts': '关联岗位',
    'PleaseInputAchievement': '请输入绩效',
    'noQualification': '暂无资质',
    'noTraining': '暂无培训'
  }
}



// WEBPACK FOOTER //
// ./src/common/lang/zh.js